import type { ComponentProps, FC } from "react";

import { cn } from "../../utils";
import { Column } from "../column";
import { useAppNav } from "./app-nav-provider";

export const AppNavColumn: FC<ComponentProps<typeof Column>> = ({ children, className, ...props }) => {
  const { isCollapsed } = useAppNav();

  return (
    <Column
      {...props}
      data-collapsed={isCollapsed}
      className={cn("group bg-transparent flex-none w-48", className, isCollapsed && "w-(--gutter)!")}
    >
      {children}
    </Column>
  );
};
